import { LazyTooltip, TooltipProps } from '@alkem/react-ui-tooltip';
import './index.scss';

interface Props {
  extraClass: string;
  icon: string;
  id: string;
  message: TooltipProps['children'];
  place?: TooltipProps['place'];
}

export function HelpTooltip({ message, id, place, icon, extraClass }: Props) {
  return (
    <LazyTooltip id={id} tooltipLabel={message} place={place} hoverable>
      <i
        className={`helpTooltip mdi mdi-${icon} ${extraClass}`}
        data-testid={`${id}-${icon}`}
      />
    </LazyTooltip>
  );
}

HelpTooltip.defaultProps = {
  place: 'top',
  icon: 'help-circle',
  extraClass: '',
};

export default HelpTooltip;
